import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import './index.scss';

const classNames = {
  wrapper: 'text-field',
  input: 'text-field__input',
  dirtyInput: 'is-dirty',
  label: 'text-field__label',
  error: 'has-error',
};

const InputField = forwardRef((props, ref) => {
  const {
    placeholder,
    type,
    inputMode,
    pattern,
    disabled,
    id,
    value,
    onChange,
    error,
    min,
    max,
    label,
    maxlength,
  } = props;
  let inputClassNames =
    value && value.length > 0 ? `${classNames.input} ${classNames.dirtyInput}` : classNames.input;
  inputClassNames = error ? `${inputClassNames} ${classNames.error}` : inputClassNames;

  return (
    <div className={classNames.wrapper}>
      {label && (
        <label className="form-label" htmlFor={id}>
          {label}
        </label>
      )}
      <input
        type={type}
        inputMode={inputMode}
        pattern={pattern}
        id={id}
        data-testid={id}
        name={id}
        className={inputClassNames}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete="off"
        value={value || ''}
        min={min}
        max={max}
        maxLength={maxlength}
        onChange={onChange}
        ref={ref}
      />

      <label className={classNames.label} htmlFor={id}>
        {placeholder}
      </label>
    </div>
  );
});

InputField.propTypes = {
  placeholder: PropTypes.string,
  type: PropTypes.string.isRequired,
  inputMode: PropTypes.string,
  pattern: PropTypes.string,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  error: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  maxlength: PropTypes.number,
  label: PropTypes.string,
};

InputField.defaultProps = {
  placeholder: '',
  disabled: false,
  value: '',
  error: false,
};

export default InputField;
